var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getCustomerForLDClient, getCustomerMailConsents } from '../../api';
import { getLDCustomerProperties } from './buildCustomerProperties';
export const getFeatureFlagUserData = (customerId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const customerResponse = yield getCustomerForLDClient(customerId);
        return getLDCustomerProperties(customerResponse === null || customerResponse === void 0 ? void 0 : customerResponse.data);
    }
    catch (_a) {
        // eslint-disable-next-line no-console
        console.warn('Failed to load "customer" data for feature-flag params!');
        return {};
    }
});
export const getFeatureFlagConsentsData = () => __awaiter(void 0, void 0, void 0, function* () {
    var _b, _c, _d;
    let consents;
    try {
        const consentsResponse = yield getCustomerMailConsents();
        consents = (_b = consentsResponse === null || consentsResponse === void 0 ? void 0 : consentsResponse.data) === null || _b === void 0 ? void 0 : _b.consents;
    }
    catch (_e) {
        // eslint-disable-next-line no-console
        console.warn('Failed to load "consents" data for feature-flag params!');
    }
    return {
        isAlphaGroup: ((_c = consents === null || consents === void 0 ? void 0 : consents.find((consent) => consent.id === 'alpha_program')) === null || _c === void 0 ? void 0 : _c.valid) || false,
        isBetaGroup: ((_d = consents === null || consents === void 0 ? void 0 : consents.find((consent) => consent.id === 'beta_program')) === null || _d === void 0 ? void 0 : _d.valid) || false,
    };
});
//# sourceMappingURL=requestData.js.map